import { Chip, ChipProps } from '@mui/material';
import type { PipelineState } from '../types';
import { STATE_LABELS } from './format';

const COLORS: Record<PipelineState, ChipProps['color']> = {
  DRAFT: 'default',
  SHADOW: 'info',
  LIVE: 'success',
  PAUSED: 'warning',
  NEEDS_ATTENTION: 'error'
};

export default function StateChip({ state }: { state: PipelineState }) {
  return (
    <Chip
      size="small"
      variant={state === 'DRAFT' ? 'outlined' : 'light'}
      color={COLORS[state] ?? 'default'}
      label={STATE_LABELS[state] ?? state}
      sx={{ fontWeight: 600 }}
    />
  );
}
